export default {
  // Nav
  "brand": "USFansLink",
  "nav.home": "Home",
  "nav.categories": "Categories",
  "nav.guides": "Guides",
  "nav.faq": "FAQ",
  "nav.cta": "Explore Spreadsheet",
  "nav.shoppingGuide": "Shopping Guide",

  // Hero
  "hero.badge": "Updated for 2026",
  "hero.title": "USFans Spreadsheet — Finds, QC, W2C & Buying Guides",
  "hero.subtitle": "One organized place to explore USFans product finds, categories, QC info, W2C links, shipping guides and honest buying tips before you order.",
  "hero.search": "Search categories, QC, W2C, shipping or reviews...",
  "hero.cta1": "USFans Spreadsheet",
  "hero.cta2": "Buy It Now",

  // Trust
  "trust.1": "Updated Resources",
  "trust.2": "Independent Information",
  "trust.3": "Beginner-Friendly Guides",

  // Categories
  "categories.badge": "Product Categories",
  "categories.title": "Browse Product Categories",
  "categories.subtitle": "Jump straight to the category you need on the main website.",
  "categories.dropdownLabel": "Choose a category",
  "categories.dropdownPlaceholder": "Select a category to explore",
  "categories.empty": "No categories match your search.",
  "categories.visit": "View category",

  // Category names
  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants / Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear / Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  // What Is
  "whatis.title": "What Is the USFans Spreadsheet?",
  "whatis.p1": "The USFans Spreadsheet is an organized resource for discovering products, product links, QC information and buying resources. Instead of searching through scattered links, a well-structured spreadsheet makes it easier to explore products, categories and useful guides in one place.",
  "whatis.p2": "Whether you are looking for shoes, hoodies, jerseys or accessories, the spreadsheet helps you move from a product idea to a verified link and a clear checklist of what to check before you place an order.",
  "whatis.cta": "Explore the Spreadsheet",

  // Features
  "features.title": "Everything You Need Before You Buy",
  "features.subtitle": "Practical resources that help you research, compare and order with more confidence.",
  "feature.1.title": "USFans Spreadsheet",
  "feature.1.desc": "Explore organized product resources and category links in one place.",
  "feature.2.title": "QC Guide",
  "feature.2.desc": "Learn what to check and how to read quality-check photos before ordering.",
  "feature.3.title": "W2C Links",
  "feature.3.desc": "Understand product links and W2C resources so you can find what you want.",
  "feature.4.title": "Shipping Cost",
  "feature.4.desc": "Learn what affects your final shipping cost and how to plan your budget.",
  "feature.5.title": "USFans Review",
  "feature.5.desc": "Understand the service, its workflow and its limitations before you use it.",
  "feature.6.title": "USFans Safety",
  "feature.6.desc": "Learn how to reduce common online risks and shop more carefully.",

  // Article CTA
  "articleCta.title": "Read the Complete Guide",
  "articleCta.subtitle": "New to the USFans Spreadsheet? Start with our beginner-friendly guide to understand how everything works.",
  "articleCta.button": "Read the USFans Spreadsheet Guide",
  "articleCta.note": "Guides • Reviews • Safety Tips",

  // FAQ
  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Quick answers to the most common questions about the USFans Spreadsheet.",
  "faq.1.q": "What is the USFans Spreadsheet?",
  "faq.1.a": "It is an organized collection of product links, categories, QC information and buying resources that helps you discover and research products before ordering.",
  "faq.2.q": "How does USFans work?",
  "faq.2.a": "USFans acts as a shopping and forwarding service. You find a product link, place it through the service, and it helps with purchasing, QC checks and shipping to your address.",
  "faq.3.q": "Is USFans legit?",
  "faq.3.a": "USFans is a widely discussed shopping service, but you should always do your own research, read recent community feedback and verify seller and payment details before ordering.",
  "faq.4.q": "Is USFans safe?",
  "faq.4.a": "No online shopping is completely risk-free. Reduce risk by checking seller reviews, confirming QC photos and using secure payment methods.",
  "faq.5.q": "How much does USFans shipping cost?",
  "faq.5.a": "Shipping cost depends on package weight, dimensions, destination and the shipping method you choose. Consolidation can help reduce the total cost.",
  "faq.6.q": "What is a USFans warehouse?",
  "faq.6.a": "A warehouse stores your items after purchase, where QC photos are taken and parcels are consolidated before international shipping.",
  "faq.7.q": "Where can I find USFans W2C links?",
  "faq.7.a": "W2C links are usually shared in the spreadsheet or community resources. Always verify a link before using it.",
  "faq.8.q": "Are USFans coupons available?",
  "faq.8.a": "Promotions and discounts can change frequently. Check the main website for current offers and verify any coupon before using it.",

  // Guides section
  "guides.badge": "Pillar Guides & Articles",
  "guides.title": "USFans Guides & Pillar Articles",
  "guides.subtitle": "Original, in-depth guides on reviews, shipping, QC, W2C, safety and more.",
  "guides.readMore": "Read article",

  // Final CTA
  "final.title": "Ready to explore the USFans Spreadsheet?",
  "final.subtitle": "Browse product categories, find QC and W2C resources, and order with a clearer plan.",
  "final.button": "Explore the USFans Spreadsheet",

  // Footer
  "footer.tagline": "Your independent resource hub for the USFans Spreadsheet — product finds, QC, W2C, shipping and buying guides.",
  "footer.disclaimer": "USFansLink is an independent informational resource. Unless explicitly stated, it is not affiliated with, endorsed by, or operated by USFans.",
  "footer.explore": "Explore",
  "footer.resources": "Resources",
  "footer.legal": "Legal",
  "footer.home": "Home",
  "footer.categories": "Categories",
  "footer.guide": "USFans Spreadsheet Guide",
  "footer.faq": "FAQ",
  "footer.mainSite": "Main Website",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Use",
  "footer.disclaimerTitle": "Disclaimer",
  "footer.rights": "All rights reserved.",
};